export default {"src":"/_next/static/media/stopwatch_24.a32a8b47.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};